


















































































import Vue from "vue";
import ApiService from "@/services/ApiService";
import { Content, MeldungDetail } from "@/types";
import Fieldset, { Field } from "@/components/ui/Fieldset.vue";
import FieldFiles from "@/components/ui/FieldFiles.vue";
import ToTopButton from "@/components/layout/ToTopButton.vue";
import FieldCollapse, {
  CollapseField,
} from "@/components/ui/FieldCollapse.vue";

export default Vue.extend({
  name: "MeldungDetail",
  components: { Fieldset, FieldCollapse, FieldFiles, ToTopButton },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      isLoading: false,
      title: "",
      readView: false,
      meldung: {} as MeldungDetail,
    };
  },
  computed: {
    parsedId(): number {
      let id: number;
      try {
        id = Number.parseInt(this.id);
      } catch (err) {
        this.onBack();
        id = 0;
      }
      return id;
    },

    /**
     * different fields for 1-5, 7, 8
     */
    generalFields(): Field[] {
      //all
      const fields = [{ key: "absender", label: "(A) Meldung durch" }];
      // only 8
      if (this.meldung.info.typId == 8)
        fields.push({ key: "nachrichtentyp", label: "Nachrichtentyp" });
      // only 1-5
      else if (this.meldung.info.typId || 0 <= 5)
        fields.push({ key: "ereignis", label: "(B) Ereignis" });

      return fields;
    },

    tableFields(): Field[] | undefined {
      // all
      const fields = [
        { key: "ort", label: "Bezeichnung" },
        { key: "datum", label: "Datum" },
        { key: "zeit", label: "Uhrzeit" },
        { key: "gewaesser", label: "Gewässer" },
        { key: "uferseite", label: "Uferseite" },
      ];
      // only 1-5
      if (this.meldung.info.typId || 0 <= 5)
        fields.push({ key: "km", label: "Fluss km" });
      // dont show this on info typ 8
      if (this.meldung.info.typId == 8) return undefined;

      return fields;
    },

    collapsedFields(): CollapseField[] | undefined {
      let fields;
      // fileds for typ 1-5
      if (this.meldung.info.typId || 0 <= 5)
        fields = [
          {
            title: "Hydrologische Daten",
            fields: [
              { key: "pegel", label: "Pegel" },
              { key: "wasserstand", label: "Wasserstand (cm)" },
              { key: "abfluss", label: "Abfluss (m<sup>³</sup>/s)" },
            ] as Field[],
          },
          {
            title: "(D) Stoffinformationen",
            fields: [
              { key: "stoff", label: "Stoff" },
              { key: "casNr", label: "CAS-Nr." },
              { key: "konzentration", label: "Konzentration" },
              {
                key: "menge",
                label: "Eingetragene Menge (kg)",
                custom: (data: Content) => data.menge || "" + data.method || "",
              },
              { key: "dauer", label: "Einfließdauer" },
            ] as Field[],
          },
          {
            title: "(E) Ausmaß der Verschmutzung",
            fields: [
              { key: "ausmass" },
              { key: "laenge", label: "Länge" },
              { key: "breite", label: "Breite" },
            ] as Field[],
          },
          {
            title: "(F) Getroffene Maßnahmen",
            fields: [{ key: "massnahmen" }],
          },
          {
            title: "(H) Medienreaktion",
            fields: [{ key: "medienreaktion" }],
          },
          {
            title: "Weitere Informationen",
            fields: [{ key: "informationen" }],
          },
        ] as CollapseField[];

      // fileds for typ 7
      if (this.meldung.info.typId == 7)
        fields = [
          {
            title: "Entwarnte Strecke",
            fields: [
              { key: "entwarnung" },
              { key: "vonKM", label: "von Km" },
              { key: "bisKM", label: "bis Km" },
            ],
          },
          {
            title: "Begründung",
            fields: [{ key: "begruendung" }],
          },
        ] as CollapseField[];

      // fileds for typ 8
      if (this.meldung.info.typId == 8)
        fields = [
          {
            title: "Mittteilung",
            fields: [{ key: "mitteilung" }],
          },
        ] as CollapseField[];

      return fields;
    },
  },
  mounted() {
    this.loadMeldung();
  },
  methods: {
    loadMeldung(): void {
      this.isLoading = true;
      // load detailed meldung
      ApiService.getMeldung(this.parsedId)
        .then((res: MeldungDetail) => {
          this.meldung = res;
          // if meldung is not read
          if (!this.meldung.actions.gelesen)
            // set meldung as read
            ApiService.readMeldung(this.parsedId).then(
              () => (this.meldung.actions.gelesen = 1)
            );
        })
        .finally(() => (this.isLoading = false));
    },
    onConfirm() {
      if (!this.meldung.actions.bestaetigt) {
        ApiService.confirmMeldung(this.parsedId);
      }
    },
    getValue(key: string) {
      return (this.meldung.content as any)[key];
    },
    openPDF() {
      const baseUrl = process.env.VUE_APP_BASE_URL;
      window.open(baseUrl + `meldung/${this.id}/pdf`, "_blank");
    },
    onBack() {
      this.$router.back();
    },
  },
});
